export default {
  template: `
  <template label="${edicom.locale.translate('enrollment.accounts_end.step')}">
    <ewc-title level="3" label="${edicom.locale.translate('enrollment.accounts_end.title')}"></ewc-title>
    <ewc-alert type="flat">
      <div style="white-space:normal;">${edicom.locale.translate('enrollment.accounts_end.content')}</div>
      </div>
    </ewc-alert>
  </template>`,
};
